// extracted by mini-css-extract-plugin
module.exports = {"miniPlayerRoot":"mini-player_miniPlayerRoot__hAcys","miniPlayerContent":"mini-player_miniPlayerContent__rpgk2","miniPlayerHandle":"mini-player_miniPlayerHandle__tPtPo"};